export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGINATION = { current: 1, pageSize: DEFAULT_PAGE_SIZE };
